import {
  GET_LOCALSTORAGE_AUTH,
  SET_LOCALSTORAGE_AUTH,
  REMOVE_LOCALSTORAGE_AUTH,
} from './types';

export const getLocalStorageAuth = () => (dispatch) => {
  const auth = window.localStorage.getItem('auth');
  console.log('auth in getLocalStorageAuth action', auth);
  dispatch({
    type: GET_LOCALSTORAGE_AUTH,
    payload: JSON.parse(auth),
  });
};

export const setLocalStorageAuth = (data) => (dispatch) => {
  window.localStorage.setItem('auth', JSON.stringify(data));
  dispatch({
    type: SET_LOCALSTORAGE_AUTH,
    payload: data,
  });
};

export const removeLocalStorageAuth = () => (dispatch) => {
  window.localStorage.removeItem('auth');
  dispatch({
    type: REMOVE_LOCALSTORAGE_AUTH,
    payload: { token: null },
  });
};
